export default "__VITE_ASSET__B7KYFt8Q__"